import { useEffect } from 'react';
import styled from 'styled-components';

interface Props {
  showFileModal: boolean;
  setShowFileModal: (value: boolean) => void;
  attachmentFile: {
    title: string;
    link: string;
  }[];
  linkSet: any;
}

const AttachmentFileModal = ({
  showFileModal,
  setShowFileModal,
  attachmentFile,
  linkSet,
}: Props) => {
  const type = window.location.pathname.split('/')[1] === 'auction' ? 'a' : 'p';

  const auctionFileData = [
  { title: '매각물건명세서', link: linkSet?.buttonLink?.assetDetail ?? '' },
  { title: '감정평가서', link: linkSet?.buttonLink?.appraisal ?? '' },
  { title: '현황조사서', link: linkSet?.buttonLink?.statusSurvey ?? '' },
  { title: '문건/송달내역', link: linkSet?.buttonLink?.documentsHistory ?? '' },
  // { title: '토지등기', link: linkSet?.buttonLink?.landRegister ?? '' },
];
  useEffect(() => {
    if (showFileModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showFileModal]);

  
  return (
    <Container>
      <Popup>
        <TitleBox>
          <Title>첨부파일</Title>
          <CloseButton
            onClick={() => {
              setShowFileModal(false);
            }}
          >
            <img src="/assets/images/close/close_black.svg" alt="Close" />
          </CloseButton>
        </TitleBox>
        <ContentBox>
          {type === 'p' &&
            attachmentFile.map((item, index) => (
              <FileRow key={index}>
                <div>{item.title}</div>
                <OpenLinkButton
                  onClick={() => {
                    window.open(
                      `https://kr.object.ncloudstorage.com/npl-images/${item.link}`,
                      '_blank',
                    );
                  }}
                >
                  열람
                </OpenLinkButton>
              </FileRow>
            ))}
          {type === 'a' &&
            auctionFileData
              .filter((item) => item.link !== '' && item.link !== null)
              .map((item, index) => (
                <FileRow key={index}>
                  <div>{item.title}</div>
                  <OpenLinkButton
                    onClick={() => {
                      window.open(item.link, '_blank');
                    }}
                  >
                    열람
                  </OpenLinkButton>
                </FileRow>
              ))}
        </ContentBox>
        <SubmitButtonContainer>
          <CloseModalButtoon
            onClick={() => {
              setShowFileModal(false);
            }}
          >
            닫기
          </CloseModalButtoon>
        </SubmitButtonContainer>
      </Popup>
    </Container>
  );
};

export default AttachmentFileModal;

const Container = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.52);
  position: fixed;
  top: 0;
  z-index: 10000;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Popup = styled.div`
  width: 360px;
  height: 90%;
  border-radius: 16px;
  overflow: hidden;
  background-color: #fff;
  display: flex;
  flex-direction: column;
`;

const TitleBox = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  border-bottom: 1px solid rgba(23, 30, 38, 0.1);
  box-sizing: border-box;
`;

const Title = styled.div`
  flex: 1;
  text-align: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  color: #171e26;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const ContentBox = styled.div`
  width: 100%;
  height: calc(100% - 150px);
  padding: 16px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const FileRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid rgba(23, 30, 38, 0.1);
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #171e26;
`;

const OpenLinkButton = styled.button`
 min-width: 54px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background: #008aff;
  color: #fff;
  cursor: pointer;
  border:none;
`;

const SubmitButtonContainer = styled.div`
  padding: 24px 16px;
  width: 100%;
  background-color: #fff;
`;

const CloseModalButtoon = styled.button`
  width: 100%;
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid rgba(23, 30, 38, 0.78);
  background: none;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(23, 30, 38, 0.78);
  font-family: Spoqa Han Sans Neo;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
`;
